import { render, staticRenderFns } from "./symbol-favorite.vue?vue&type=template&id=3d19e3e9&"
import script from "./symbol-favorite.vue?vue&type=script&lang=js&"
export * from "./symbol-favorite.vue?vue&type=script&lang=js&"
import style0 from "./symbol-favorite.vue?vue&type=style&index=0&id=3d19e3e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports